import "./Contact.css";

function Contact() {
    return (
        <footer className="contact" id="contact">
            <h1>Me contacter</h1>
            <ul>
                <li>
                    <a href="mailto:mirandalucas52@gmail.com">
                        mirandalucas52@gmail.com
                    </a>
                </li>
                <li>
                    <a href="https://github.com/mirandalucas52">Mon Github</a>
                </li>
                <li>
                    <a href="https://www.linkedin.com/in/lucas-miranda-b17261211/">
                        Mon Linkedin
                    </a>
                </li>
                <li>Ile-de-France</li>
            </ul>
        </footer>
    );
}

export default Contact;
